import Api from 'src/util/api';

// 查询湖南设备列表
export function listPointDevice(data) {
    return Api.post('/monitor/hunan/point/device/data/other/real', data);
}

// export function getDrainageOverview(data) {
//     return Api.get('/huzhou_monitor/drainage_overview/get', data);
// }

